import React from "react";
import {
  TrendingUp,
  Calendar,
  PenTool,
  UserCheck,
  NotepadText,
} from "lucide-react";
import { Link } from "react-router-dom";

const colorMap = {
  red: "from-red-400 to-red-600",
  green: "from-pink-500 to-pink-700",
  blue: "from-blue-400 to-blue-700",
  purple: "from-purple-600 to-purple-800",
};

const iconMap = {
  calendar: <Calendar className="w-6 h-6 text-white" />,
  pen: <PenTool className="w-6 h-6 text-white" />,
  chart: <TrendingUp className="w-6 h-6 text-white" />,
  user: <UserCheck className="w-6 h-6 text-white" />,
  result: <NotepadText className="w-6 h-6 text-white" />,
};

const DashboardCard = ({
  title,
  value,
  icon = "chart",
  color = "blue",
  to,
}) => {
  const gradient = colorMap[color] || colorMap["blue"];

  return (
    <Link
      to={to}
      className={`bg-gradient-to-r ${gradient} flex-col shadow-lg hover:shadow-xl transition-all duration-300 rounded-xl p-5 flex items-start gap-3 cursor-pointer circle-after`}
    >
      <div className="w-10 h-10 rounded-xl bg-black bg-opacity-20 flex items-center justify-center">
        {iconMap[icon]}
      </div>
      <div className="text-white">
        <p dir="ltr" className="text-3xl font-bold mb-2">{value}</p>
        <p className="text-sm opacity-80">{title}</p>
      </div>
    </Link>
  );
};

export default DashboardCard;
